import React, { Component } from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';


class DatePickerComponent extends Component {
  constructor(props) {
    super(props);
    this.state = this.props.selectedDates
  }

  componentDidUpdate() {
    if (this.props.selectedDates.from !== this.state.from
      || this.props.selectedDates.to !== this.state.to) {
      this.setState(this.props.selectedDates);
    }
  }

  handleDayClick = (day) => {
    const range = DateUtils.addDayToRange(day, this.state);
    this.props.setDates(range);
    this.setState(range);
  }

  render() {
    const modifiers = { start: this.state.from, end: this.state.to };
    if (!this.props.noDisabledDates) {
      modifiers.disabled = { before: new Date() }
    }
    return (<div className="date-picker-container">
      <DayPicker
        selectedDays={this.state}
        onDayClick={this.handleDayClick}
        numberOfMonths={1}
        canChangeMonth={true}
        modifiers={modifiers}
        className="Selectable"
      />
    </div>);
  }
}

export default DatePickerComponent;
